const ITEMS = [
  "Tradition in every stitch",
  "Est. United Kingdom",
  "Blackwatch Tartan",
  "Scottish Tweeds",
  "Waxed Cotton",
  "Honest Work",
  "Skilled Hands",
];

export default function Marquee() {
  return (
    <div
      data-testid="heritage-marquee"
      className="overflow-hidden border-y border-line bg-ivory py-6 select-none"
      aria-hidden="true"
    >
      <div className="marquee-track">
        {[0, 1].map((copy) => (
          <div key={copy} className="flex shrink-0 items-center">
            {ITEMS.map((item) => (
              <span key={`${copy}-${item}`} className="flex items-center">
                <span className="font-serif italic text-2xl md:text-3xl text-ink/70 px-8 whitespace-nowrap">
                  {item}
                </span>
                <span className="text-honey text-sm">◆</span>
              </span>
            ))}
          </div>
        ))}
      </div>
    </div>
  );
}
